/**
 * 常量
 *
*/

//终端参数-版本信息
export const TERMINAL_VERSION = 'params/TERMINAL_VERSION';
//终端参数-上线时间(连接状态)
export const TERMINAL_LINK_STATUS = 'params/TERMINAL_LINK_STATUS';
//终端参数-端口信息
export const TERMINAL_PORT = 'params/TERMINAL_PORT';

//电表配置-列表数据
export const METER_DATA = 'params/METER_DATA';

//任务配置-列表数据
export const TASK_DATA = 'params/TASK_DATA';

//时段定义-列表数据
export const TIME_DATA = 'params/TIME_DATA';

//通讯协议
export const protocol = 'params/PROTOCOL';
//连接方式
export const connectionMethod = 'params/CONNECTIONMETHOD';

export const productList = 'params/PRODUCTLIST';

export const assetCodeInfo = 'params/ASSETCODEINFO';


